import React from 'react';
import styled from 'styled-components';

const CDN_BASE = `${process.env.REACT_APP_SAFRA_BANNER_LINKS}/media/icons`;

const toCss = (value) =>
  typeof value === 'number' ? `${value}px` : value;

const IconMask = styled.span`
  display: inline-block;
  width: ${({ $size }) => toCss($size)};
  height: ${({ $size }) => toCss($size)};
  background-color: ${({ $color }) => $color};
  -webkit-mask: url('${({ $src }) => $src}') no-repeat center / contain;
  mask: url('${({ $src }) => $src}') no-repeat center / contain;
  flex-shrink: 0;
  vertical-align: middle;
`;

function Icon({
  name,
  src,
  size = 24,
  color = 'currentColor',
  className,
  style,
  onClick,
  title,
  ...rest
}) {
  const url = src || (name ? `${CDN_BASE}/${name}.svg` : null);
  if (!url) return null;
  return (
    <IconMask
      $src={url}
      $size={size}
      $color={color}
      className={className}
      style={style}
      onClick={onClick}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      {...rest}
    />
  );
}

export default Icon;
